export default {
    changeFontSize: ({ commit }, param) => commit('CHANGE_FONT_SIZE', param),
    setRouteName: ({ commit }, param) => commit('GET_ROUTE_NAME', param),
    setRemainTime: ({ commit }, param) => commit('GET_REMAIN_TIME', param),
    setSocketType: ({ commit }, param) => commit('GET_SOCKET_TYPE', param),
    setSocketData: ({ commit }, param) => commit('GET_SOCKET_DATA', param)
}




// WEBPACK FOOTER //
// ./src/store/anscart/action.js